import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {
    Execution,
    ExecutionFilterDate,
    ExecutionFilters,
    ExecutionLight,
    ExecutionUI,
} from '@store/operations/executions/executions.model';
import {TableConfig} from '@constants/table.constants';
import {TablePagination} from '@store/common/pagination.model';

export interface ExecutionsState {
  filters: ExecutionFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  linkedExecution?: ExecutionLight[];
}

export const executionsStore = createStore(
  { name: 'executions' },
  withProps<ExecutionsState>({
    filters: { search: '', tableFilters: ExecutionFilters.initTableFilters(), filterDate: ExecutionFilterDate.PLANNED },
    sort: {
      field: 'execution.createdAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Execution>(),
  withUIEntities<ExecutionUI>(),
  withPagination(),
  withRequestsStatus()
);
